<template>
    <div class="CapacitanceCompensation">
        <div class="tag">
            <span :class="{active:active=='0'}" @click="active=0">电容补偿</span>
            <span :class="{active:active=='1'}" @click="active=1" v-if="projectId==4||projectId==19">谐波分析</span>
        </div>
        <div class="cont">
            <EPCC v-show="active=='0'"></EPCC>
            <Harmonic v-if="active=='1'"></Harmonic>
        </div>
    </div>
</template>

<script>
    import EPCC from './EPCC'
    import Harmonic from './Harmonic'
    export default {
        name: "CapacitanceCompensation",
        components: {
            EPCC,
            Harmonic
        },
        data() {
            return {
                active:0
            }
        },
        computed:{
            projectId(){
                return this.$store.getters.projectId
            },
        },
        watch:{
            active(n,o){

            }
        },
        created(){
            this.$store.commit('setAreaId', this.$store.getters.getTypeSite('distribution')[0].areaId)
        },
    };
</script>

<style lang="less" scoped>
.CapacitanceCompensation{
    height: 100%;
    width: 100%;
    background: #ffffff;
    .cont{
        height: calc(100% - 50rem);
        padding:0 20rem 20rem 20rem;
        overflow: auto;
    }
    .tag{
        padding: 0 20rem;
        height: 50rem;
        span{
            line-height: 50rem;
            margin-right: 30rem;
            vertical-align: middle;
            border-top: 3rem solid #fff;
            cursor: pointer;
            display: inline-block;
            font-size: 16rem;
            font-weight: bold;
        }
        .active{
            border-top: 3rem solid #0d94ff;
            color: #0d94ff;
        }
   }
}
   
</style>